var map = {
	"./cell.png": "0cd8",
	"./charity.png": "01df",
	"./close.png": "c821",
	"./close_grey.png": "d1f8",
	"./doctor.png": "b286",
	"./flower-happy.png": "5c31",
	"./graphic.png": "c6f3",
	"./injection.png": "19f0",
	"./logo-happy.svg": "aa43",
	"./piggy-bank.png": "6b89",
	"./pill-and-tablet.png": "234b",
	"./plus.svg": "eb38",
	"./syringe.png": "33d2",
	"./target.png": "4ab9",
	"./vaccine.png": "2508"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";